import { Outlet } from 'react-router-dom';
import AppShell from '../common/AppShell/AppShell';

const Portal = () => {
  return (
    <AppShell translationRoot="portal">
      <Outlet />
    </AppShell>
  );
};

export default Portal;
